import type { UtilityContext } from '@change-corgi/core-react/utilityContext';
import type { AuthMethod } from '@change-corgi/middle-end-gql-schema';

import {
	UserAuthMethod,
	type UserAuthMethodQuery,
	type UserAuthMethodQueryVariables,
} from './getEmailAuthMethod.graphql';

export async function getEmailAuthMethod(email: string, { gql: { fetch } }: UtilityContext): Promise<AuthMethod> {
	const { data } = await fetch<UserAuthMethodQuery, UserAuthMethodQueryVariables>({
		query: UserAuthMethod,
		variables: { email },
		path: '/userAuthMethodByEmail',
		rejectOnError: true,
		batched: false, // to ensure this rate limited mutation is not batched
	});
	return data.authMethod;
}
